var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper",style:({ height: '100%', 'overflow-y': 'auto' })},[_c('v-data-table',{ref:"dataTable",staticClass:"elevation-0 tt",attrs:{"hide-default-footer":"","height":"100%","headers":_vm.headers,"items":_vm.tableItems,"items-per-page":_vm.data.length}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }